module.exports = __webpack_public_path__ + "img/frame1.69161cac.jpg";